  document.addEventListener('DOMContentLoaded', function() {
    // 收集所有图片 URL
    const thumbnailContainer = document.getElementById('mainSwiper');
    if (!thumbnailContainer) return;

    const thumbnailSlides = thumbnailContainer.querySelectorAll('.swiper-slide img');
    const imageUrls = [];
    const isMobile = window.innerWidth <= 768;

    thumbnailSlides.forEach((img, index) => {
      imageUrls.push(img.src);
      
      // 所有设备（PC和移动端）都点击打开弹窗
      img.parentElement.addEventListener('click', () => {
        openLightbox(index);
      });
    });

    if (imageUrls.length === 0) return;

    // 创建弹窗 HTML
    let lightboxHTML = `
      <div class="lightbox-modal" id="lightboxModal">
        <button class="lightbox-close" id="lightboxClose">×</button>
        <div class="lightbox-swiper-container">
          <button class="lightbox-nav lightbox-prev" id="lightboxPrev">‹</button>
          <button class="lightbox-nav lightbox-next" id="lightboxNext">›</button>
          <div class="swiper lightbox-swiper" id="lightboxSwiper">
            <div class="swiper-wrapper">
    `;

    imageUrls.forEach(url => {
      lightboxHTML += `
        <div class="swiper-slide">
          <div class="swiper-zoom-container">
            <img src="${url}" alt="Product Image">
          </div>
        </div>
      `;
    });

    lightboxHTML += `
            </div>
          </div>
        </div>
        <div class="zoom-hint" id="zoomHint">Double-tap image to zoom</div>
        <div class="lightbox-pagination" id="lightboxPagination"></div>
      </div>
    `;

    // 将弹窗添加到页面
    document.body.insertAdjacentHTML('beforeend', lightboxHTML);

    // 初始化 swiper
    let lightboxSwiper = null;

    function initLightboxSwiper(initialIndex) {
      if (lightboxSwiper) {
        lightboxSwiper.destroy();
      }

      const isMobile = window.innerWidth <= 768;
      
      const swiperOptions = {
        slidesPerView: 1,
        initialSlide: initialIndex,
        navigation: {
          nextEl: '#lightboxNext',
          prevEl: '#lightboxPrev',
        },
        pagination: {
          el: '#lightboxPagination',
          clickable: true,
        },
        keyboard: {
          enabled: true,
        },
      };

      // 移动端添加zoom功能
      if (isMobile) {
        swiperOptions.zoom = {
          maxRatio: 3,
          minRatio: 1,
          toggle: true,
        };
      }

      lightboxSwiper = new Swiper('#lightboxSwiper', swiperOptions);
    }

    // 打开弹窗
    function openLightbox(index) {
      const modal = document.getElementById('lightboxModal');
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      initLightboxSwiper(index);
    }

    // 关闭弹窗
    function closeLightbox() {
      const modal = document.getElementById('lightboxModal');
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }

    // 事件监听
    document.getElementById('lightboxClose').addEventListener('click', closeLightbox);
    document.getElementById('lightboxModal').addEventListener('click', function(e) {
      if (e.target === this) {
        closeLightbox();
      }
    });

    // ESC 键关闭
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const modal = document.getElementById('lightboxModal');
        if (modal.classList.contains('active')) {
          closeLightbox();
        }
      }
    });

    // 窗口大小变化时重新初始化swiper
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        const modal = document.getElementById('lightboxModal');
        if (modal.classList.contains('active') && lightboxSwiper) {
          const currentIndex = lightboxSwiper.activeIndex;
          initLightboxSwiper(currentIndex);
        }
      }, 250);
    });
  });
